module.exports = __webpack_public_path__ + "img/header-weddingRingsStylesCreative@2x.108f4a6.webp";